/* eslint-disable no-tabs */
/*
 *  DIGITALX LABS(PVT)LTD PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  Copyright © 2019. DIGITALX LABS(PVT)LTD
 *  All Rights Reserved.
 *
 *  NOTICE:  All information contained herein is, and remains
 *  the property of DIGITALX LABS(PVT)LTD.  The intellectual and technical concepts contained
 *  herein are proprietary to DIGITALX LABS(PVT)LTD.
 *  Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  is strictly forbidden unless prior written permission is obtained from DIGITALX LABS(PVT)LTD.
 */

import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import LotteryBaseLayout from './containers/Layouts/LotteryBaseLayout'
import { RoutesConstant } from './util/constants'
import AppContextProvider from './context/AppContextProvider'
import ModalContextProvider from './context/ModalContextProvider'
import AuthContextProvider from './context/AuthContextProvider'
import MessageHandlerContextProvider from './context/MessageHandlerContextProvider'
const App = () => {
  return (
		<MessageHandlerContextProvider>
			<AuthContextProvider>
				<AppContextProvider>
					<ModalContextProvider>
						<Router>
							<Switch>
								<Route path={RoutesConstant.HOME_ROUTE} render={props => <LotteryBaseLayout {...props} />} />
								{/* <Route path={RoutesConstant.HOME_ROUTE} render={props => <DefaultLayout {...props} />} /> */}
							</Switch>
						</Router>
					</ModalContextProvider>
				</AppContextProvider>
			</AuthContextProvider>
		</MessageHandlerContextProvider>
  )
}

export default App
